import dayjs from 'dayjs';
import { CARD_FORM_INITIAL_VALUES } from './cardContext';
import {
    CARD_FORM_ERROR,
    CLOSE_CARD_FORM_MODAL,
    CLOSE_CONFIRM_ADDRESS_MODAL,
    CLOSE_CONFIRM_EXIT_DIALOG,
    CLOSE_CREATE_NEW_CARD,
    CLOSE_EDIT_CARD_FORM_MODAL,
    CLOSE_EDIT_CARD_FUNDS_MODAL,
    CLOSE_NO_BALANCE_MODAL,
    CLOSE_PASSWORD_MODAL,
    CLOSE_PHYSICAL_CARD_FORM_MODAL,
    CLOSE_SHIPPING_ADDRESS_MODAL,
    CLOSE_USER_FORM_MODAL,
    ERROR_FRAMES,
    GET_CARDHOLDERS,
    GET_CARDS,
    HIDE_CARD_FORM_MODAL,
    HIDE_CARD_INFO,
    LOAD_MCC_CODE,
    OPEN_CARD_FORM_MODAL,
    OPEN_CONFIRM_ADDRESS_MODAL,
    OPEN_CONFIRM_EXIT_DIALOG,
    OPEN_CREATE_NEW_CARD,
    OPEN_EDIT_CARD_FORM_MODAL,
    OPEN_EDIT_CARD_FUNDS_MODAL,
    OPEN_NO_BALANCE_MODAL,
    OPEN_PASSWORD_MODAL,
    OPEN_PHYSICAL_CARD_FORM_MODAL,
    OPEN_SHIPPING_ADDRESS_MODAL,
    OPEN_USER_FORM_MODAL,
    REMOVE_FRAME,
    SAVE_TOKENS,
    SET_CARD,
    SET_CARDS,
    SET_FORM_SUMITTING,
    SHOW_CARD_FORM_MODAL,
    SHOW_CARD_INFO,
    UPDATE_CARD_LIST,
    UPDATE_CARDS_METADATA,
    OPEN_REQUEST_NEW_CARD,
    CLOSE_REQUEST_CARD_FORM_MODAL,
    OPEN_REVIEW_NEW_CARD,
    CLOSE_REVIEW_CARD_FORM_MODAL,
    OPEN_REQUEST_EDIT_CARD_LIMIT,
    CLOSE_REQUEST_EDIT_CARD_LIMIT_MODAL
} from './types';

export const cardsReducer = (state, action) => {
    switch (action.type) {
        case SET_CARD:
            return {
                ...state,
                cardId: action.payload.id,
                card: {
                    ...action.payload,
                    autoLock: action.payload.autoLock ? dayjs(action.payload.autoLock) : action.payload.autoLock
                },
                previousCard: {
                    ...action.payload,
                    autoLock: action.payload.autoLock ? dayjs(action.payload.autoLock) : action.payload.autoLock
                }
            };
        case OPEN_CREATE_NEW_CARD:
            return {
                ...state,
                card: CARD_FORM_INITIAL_VALUES,
                isCardFormModalOpen: true,
                errorMessage: '',
                cardId: null
            };
        case LOAD_MCC_CODE:
            return {
                ...state,
                mccCodes: action.payload
            };
        case CLOSE_CREATE_NEW_CARD:
            return {
                ...state,
                isCardFormModalOpen: false,
                shouldUpdateCardList: false,
                cardId: null
            };
        case GET_CARDS:
            return {
                ...state,
                shouldUpdateCardList: true
            };
        case OPEN_CARD_FORM_MODAL:
            return {
                ...state,
                isCardFormModalOpen: true
            };
        case CLOSE_CARD_FORM_MODAL:
            return {
                ...state,
                card: CARD_FORM_INITIAL_VALUES,
                isCardFormModalOpen: false,
                errorMessage: ''
            };
        case OPEN_EDIT_CARD_FORM_MODAL:
            return {
                ...state,
                isEditCardFormModalOpen: true
            };
        case CLOSE_EDIT_CARD_FORM_MODAL:
            return {
                ...state,
                card: CARD_FORM_INITIAL_VALUES,
                isEditCardFormModalOpen: false,
                errorMessage: ''
            };
        case OPEN_EDIT_CARD_FUNDS_MODAL:
            return {
                ...state,
                isEditCardFundsModalOpen: true
            };
        case CLOSE_EDIT_CARD_FUNDS_MODAL:
            return {
                ...state,
                card: CARD_FORM_INITIAL_VALUES,
                isEditCardFundsModalOpen: false,
                errorMessage: ''
            };
        case SHOW_CARD_FORM_MODAL:
            return {
                ...state,
                isCardFormModalOpen: true
            };
        case HIDE_CARD_FORM_MODAL:
            return {
                ...state,
                isCardFormModalOpen: false
            };
        case OPEN_USER_FORM_MODAL:
            return {
                ...state,
                isUserFormModalOpen: true
            };
        case CLOSE_USER_FORM_MODAL:
            return {
                ...state,
                isUserFormModalOpen: false
            };
        case OPEN_PHYSICAL_CARD_FORM_MODAL:
            return {
                ...state,
                isCardFormModalOpen: true
            };
        case CLOSE_PHYSICAL_CARD_FORM_MODAL:
            return {
                ...state,
                card: action.payload,
                isCardFormModalOpen: false,
                errorMessage: ''
            };
        case OPEN_SHIPPING_ADDRESS_MODAL:
            return {
                ...state,
                isShippingModalOpen: true
            };
        case CLOSE_SHIPPING_ADDRESS_MODAL:
            return {
                ...state,
                isShippingModalOpen: false,
                errorMessage: ''
            };
        case OPEN_CONFIRM_ADDRESS_MODAL:
            return {
                ...state,
                isConfirmAddressModalOpen: true
            };
        case CLOSE_CONFIRM_ADDRESS_MODAL:
            return {
                ...state,
                card: CARD_FORM_INITIAL_VALUES,
                isConfirmAddressModalOpen: false,
                errorMessage: ''
            };
        case OPEN_CONFIRM_EXIT_DIALOG:
            return {
                ...state,
                isConfirmExitDialogOpen: true
            };
        case CLOSE_CONFIRM_EXIT_DIALOG:
            return {
                ...state,
                isConfirmExitDialogOpen: false
            };
        case SET_FORM_SUMITTING:
            return {
                ...state,
                isFormSubmitting: action.payload,
                errorMessage: ''
            };
        case UPDATE_CARD_LIST:
            return {
                ...state,
                cards: state.cards.map(card => {
                    if (card.id === action.payload.id) {
                        return action.payload;
                    }
                    return card;
                })
            };
        case SET_CARDS:
            return {
                ...state,
                cards: action.payload.results,
                total: action.payload.total,
                shouldUpdateCardList: false
            };
        case UPDATE_CARDS_METADATA:
            return {
                ...state,
                statistics: {
                    accountBalance: Number(action.payload?.accountBalance) || 0,
                    activeCards: action.payload?.activeCards || 0,
                    zeroBalanceCards: action.payload?.zeroBalanceCards || 0,
                    allocated: Number(action.payload?.allocated) || 0,
                    businessSpent: Number(action.payload?.businessSpent) || 0,
                    creditAvailable: parseFloat(action.payload?.creditLimit - action.payload?.allocated) || 0,
                    creditLimit: Number(action.payload?.creditLimit) || 0,
                    totalAmountSpentInCurrentMonth: Number(action.payload?.totalAmountSpentInCurrentMonth) || 0,
                    availableToAddtoCards: Number(action.payload?.availableToAddtoCards) || 0
                }
            };
        case OPEN_PASSWORD_MODAL:
            return {
                ...state,
                isPasswordModalOpen: true,
                currentCard: false,
                idCardToDisplay: action.payload
            };
        case CLOSE_PASSWORD_MODAL:
            return {
                ...state,
                idCardToDisplay: 0,
                isPasswordModalOpen: false,
                cancelLoader: true
            };
        case SHOW_CARD_INFO:
            return {
                ...state,
                isPasswordModalOpen: false,
                currentCard: true
            };
        case SAVE_TOKENS:
            return {
                ...state,
                providerToken: action.payload,
                cancelLoader: false,
                deleteFrame: false,
                currentCard: false
            };
        case HIDE_CARD_INFO:
            return {
                ...state,
                providerToken: {},
                currentCard: false,
                deleteFrame: true
            };
        case REMOVE_FRAME:
            return {
                ...state,
                deleteFrame: false
            };
        case ERROR_FRAMES:
            return {
                ...state,
                cancelLoader: true,
                currentCard: false,
                deleteFrame: true,
                providerToken: {}
            };
        case CARD_FORM_ERROR:
            return {
                ...state,
                errorMessage: action.payload
            };
        case GET_CARDHOLDERS:
            return {
                ...state,
                shouldUpdateCardholders: true
            };
        case OPEN_NO_BALANCE_MODAL:
            return {
                ...state,
                isUnallocatadBalanceModalOpen: true
            };
        case CLOSE_NO_BALANCE_MODAL:
            return {
                ...state,
                isUnallocatadBalanceModalOpen: false
            };
        case OPEN_REQUEST_NEW_CARD:
            return {
                ...state,
                card: CARD_FORM_INITIAL_VALUES,
                isRequestCardFormModalOpen: true,
                errorMessage: '',
                cardId: null
            };
        case CLOSE_REQUEST_CARD_FORM_MODAL:
            return {
                ...state,
                card: CARD_FORM_INITIAL_VALUES,
                isRequestCardFormModalOpen: false,
                errorMessage: ''
            };
        case OPEN_REVIEW_NEW_CARD:
            return {
                ...state,
                isReviewCardModalOpen: true,
                cardRequestToReview: action.payload
            };
        case CLOSE_REVIEW_CARD_FORM_MODAL:
            return {
                ...state,
                card: CARD_FORM_INITIAL_VALUES,
                isReviewCardModalOpen: false,
                errorMessage: ''
            };
        case OPEN_REQUEST_EDIT_CARD_LIMIT:
            return {
                ...state,
                isRequestEditLimitModalOpen: true,
                cardToRequestEditLimit: action.payload
            };
        case CLOSE_REQUEST_EDIT_CARD_LIMIT_MODAL:
            return {
                ...state,
                isRequestEditLimitModalOpen: false
            };
        default:
            return state;
    }
};
